import LoadingScreen from "@/ui/loadingScreen.tsx";
import {LoadScript} from "@react-google-maps/api";
import i18n from "i18next";
import {ReactNode} from "react";


interface Props {
    children:ReactNode
}

const LoadMapScript:React.FC<Props> = ({children}) => {
    return (
        <LoadScript
            language={i18n.language}
            googleMapsApiKey={import.meta.env.VITE_GOOGLE_MAP_API_KEY || ""}
            loadingElement={<LoadingScreen is_init={false} />}
        >
            
            {children}
        
        </LoadScript>
    )
}

export default LoadMapScript